import {appConfig} from '@stencil/hotels-config';
import parseDateIntoHermesString from './date-utils/parse-date-into-hermes-string';
import getLocusUrlString from './get-locus-url-string';
import {isObjectEmpty} from './common-utils';

const {defaultPartner, sortingKeyLabelMapForSRPFilterV2: sortByList} = appConfig;

export default function getSrpUrl({
  checkin,
  checkout,
  roomString,
  destination,
  locus = {},
  partner = defaultPartner,
  country = '',
  filter = {},
  shouldEncode = false,
  selectedRegionCity = {},
  newFilterData = '',
  newLocationData = '',
  mmtId = '',
  sort = '',
  openSRPForHotelSearch = false,
  hotelId = '',
  isSrpAltAcco,
  sType = '',
}) {
  // const {filter = {}, la = '', lo = ''} = srpConfig;
  const {date: checkinDate} = checkin;
  const {date: checkoutDate} = checkout;
  const {n: destinationCityName = '', _id, xtr = {}, ct = {}, t = ''} = destination;
  let cityName = destination?.name || destinationCityName;
  let cityId = _id;
  const {cc = 'in'} = xtr; // default as india

  if (ct?._id && ct?.n && (openSRPForHotelSearch || (xtr && xtr.flt))) {
    const {n: voyCityName = '', _id: voyCityId = ''} = ct;
    cityName = voyCityName;
    cityId = voyCityId;
  }

  if (cityId === appConfig.dummyVcid.code) {
    cityId = appConfig.dummyVcid.value;
  }

  const hotelQueryString = JSON.stringify({
    ci: parseDateIntoHermesString(checkinDate),
    co: parseDateIntoHermesString(checkoutDate),
    r: roomString,
  });

  let nlquery = destination && xtr && xtr.flt ? xtr.flt : null;

  let nQueryString = {};

  let tempfilterObj = {filter: {...filter}};

  let intermittent = JSON.stringify(tempfilterObj).split('/').join('');

  if (shouldEncode) {
    intermittent = encodeURIComponent(intermittent);
  }

  nQueryString = '?' + intermittent;

  const ccQ = (country && `&cc=${country}`) || '';
  const filterData = (!isObjectEmpty(newFilterData) && `&filterData=${newFilterData}`) || '';
  const locationData = (!!newLocationData && `&locationData=${newLocationData}`) || '';
  const sortApplied = !!sort ? `&sort=${sort}` : '';

  // const sb = slotSelected ? '&sb=1' : '';
  const sec = cc.toLowerCase() === 'in' ? '&sec=dom' : '&sec=int';
  const type = t === 'region' ? '&type=region' : '';
  const rCity = selectedRegionCity?.id ? `&region_city=${selectedRegionCity.id}` : '';
  const locusUrlStr = getLocusUrlString(locus);
  const hotelMMTId = mmtId ? `&mmtId=${mmtId}` : '';
  const hotel_id = (openSRPForHotelSearch && hotelId && `&hotelId=${hotelId}`) || '';
  const seoAltAcco = isSrpAltAcco ? `&altAcco=${isSrpAltAcco}` : '';
  const sTypeValue = sType ? `&sType=${sType}` : '';
  return `/${partner}/find-hotels-in-${cityName}/${cityId}/${cityId}/${hotelQueryString}/${nQueryString}${sec}${ccQ}${type}${rCity}${locusUrlStr}${filterData}${locationData}${sortApplied}${hotel_id}${hotelMMTId}${seoAltAcco}${sTypeValue}`;
  // return `/${partner}/find-hotels-in-${n}/${_id}/${_id}/${hotelQueryString}/${nQueryString}${sec}`;
}
